import { useEffect } from 'react'
import { trackExperimentViewed } from '../events/trackExperimentViewed'

export const TrackExperimentViewed = () => {
  useEffect(() => {
    trackExperimentViewed()
  }, [])

  return null
}
